/* eslint-disable import/default */
import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import configureStore from "./store/configureStore";
import { Router, Route, browserHistory } from "react-router";
import { Provider } from "react-redux";
import { syncHistoryWithStore } from "react-router-redux";
import { AppContainer } from "react-hot-loader";
import SurveyContainer from "./containers/SurveyContainer";
import app from "./app";
import "./styles/styles.scss";
require("bootstrap/dist/js/bootstrap.js");
require("bootstrap/dist/css/bootstrap.css");
require("./favicon.ico");

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);
const rootEl = document.getElementById("app");

export default render(
  <Provider store={store}>
    <Router history={history}>
      <Route
        path="/employers/:employerURLKey/locations/:locationURLKey"
        component={SurveyContainer}
      />
    </Router>
  </Provider>,
  rootEl
);

if (module.hot) {
  module.hot.accept("./app", () => {
    const NewRoot = app.default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      rootEl
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js